export function bookFormatLabel(book) {
  if (book?.format_label) return book.format_label;
  const w = Number(book?.width_mm), h = Number(book?.height_mm);
  if (w === 195 && h === 250) return "А4 формат - 195×250 мм";
  if (w === 155 && h === 210) return "А5 формат - 160×210 мм";
  return w > 0 && h > 0 ? `${w}×${h} мм` : "Формат не определён";
}